import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponseBase } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, map } from 'rxjs/operators';
import { LoginApiService } from '../services/system/login-api.service';
import { TcmApplicationManagerService } from './tcm-application-manager.service';
import { TenantCountry } from '../models/enums';
import { ErrorService } from '../services/system/error.service';
import { BroadCastEvents } from '../common/broad-cast-events.enum';
import { BroadcastService } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class TcmHttpResponseInterceptor implements HttpInterceptor {
  constructor(private appManager: TcmApplicationManagerService, private loginService: LoginApiService,
    private errorService: ErrorService,
    private broadcastService: BroadcastService) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(map((e) => this.readVersionFromResponse(e)))      
      .pipe(catchError(err => this.processResponseError(err, request.url)));
  }

  private readVersionFromResponse(event: HttpEvent<any>) {
    if (event instanceof HttpResponseBase) {

      const tcmAppVersion = event.headers.get('tcm-app-version');
      const tcmAppCountry = TenantCountry[event.headers.get('tcm-app-country')];

      this.appManager.setupServerVersion(tcmAppVersion);
      this.appManager.setupTenantCountry(tcmAppCountry);
    }

    return event;
  }

  private processResponseError(response: HttpErrorResponse, requestUrl: string) {    
    if (response instanceof HttpErrorResponse) {
      if (response.status === 401 && requestUrl.indexOf('auth/logout') < 0) {
        this.loginService.logoutAsync();
      }
    
      const errorText = response.error.error.message || response.statusText;
      this.errorService.addError(errorText);
      
      this.broadcastService.next({ name: BroadCastEvents.ServerErrorOccurred });
      
      return;
    }
    
    return response;
  }
}
